import { lazy } from 'react';

const RecipeInvestigationDefaultView = lazy(
  () => import('./default-view/RecipeInvestigationDefaultView'),
);

export const RecipeInvestigationPage = () => <RecipeInvestigationDefaultView />;
